export var SystemAlertType;
(function (SystemAlertType) {
    SystemAlertType[SystemAlertType["Error"] = 1] = "Error";
    SystemAlertType[SystemAlertType["Warning"] = 2] = "Warning";
    SystemAlertType[SystemAlertType["Info"] = 3] = "Info";
})(SystemAlertType || (SystemAlertType = {}));
export class SystemAlertModel {
    id;
    title;
    content;
    priority;
}
export class SystemAlert extends SystemAlertModel {
    constructor(model) {
        super();
        Object.keys(model).forEach((key) => {
            this[key] = model[key];
        });
    }
}
